import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Header } from '../src/components/common/Header/Header';
import { Footer } from '../src/components/common/Footer/Footer';
import Home from "./pages/Home";
import Lembawe9 from "./pages/Lembawe9";
import StreetRap from "./pages/StreetRap";
import Lhangar from "./pages/Lhangar";
import MusicPage from "./pages/Music";
import Artists from "./pages/Artists";
import BiorBo from "./pages/BiorBo";
import Gallery from "./pages/Gallery";
import Universe from "./pages/Universe";
import News from "./pages/News";
import Contact from "./pages/Contact";
import ProducutList from  './pages/Shop/ProductList/ProductList';
import NotFound from "./pages/NotFound";

const App = () => {
  return (
    <>
      <Router>
        <Header/>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/lembawe9" exact component={Lembawe9} />
          <Route path="/راب-الشوارع" exact component={StreetRap} />
          <Route path="/lhangar" exact component={Lhangar} />
          <Route path="/music" exact component={MusicPage} />
          <Route path="/artists" exact component={Artists} />
          <Route path="/burnitorburnout" exact component={BiorBo} />
          <Route path="/gallery" exact component={Gallery} />
          <Route path="/universe" exact component={Universe} />
          <Route path="/news" exact component={News} />
          <Route path="/contact" exact component={Contact} />
          <Route path="/merch" exact component={ProducutList} />
          <Route component={NotFound} />
        </Switch>
        <Footer/>
      </Router>
    </>
  );
};

export default App;
